import React, { useEffect, useState, useMemo } from 'react'
import { Card, CardContent, Typography, Box, Icon } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import { getObjectsWithFilter } from '../../api/apiClientCrud'
import { useAuth } from '../../context/AuthContext'

function MetricCard({ object, filter, field, styleCondition, title, type }) {
  const [value, setValue] = useState(null)
  const [loading, setLoading] = useState(true)
  const { user } = useAuth()

  useEffect(() => {
    let isMounted = true

    const fetchMetric = async () => {
      setLoading(true)
      try {
        const res = await getObjectsWithFilter(object, {
          ...filter,
          company_id: user.company_id
        })

        if (isMounted) {
          setValue(res?.data?.[field] ?? 0)
        }
      } catch (err) {
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchMetric()

    return () => {
      isMounted = false
    }
  }, [object, filter, field, user.company_id])

  const textColor = useMemo(
    () => (styleCondition ? styleCondition(value) ?? 'black' : 'black'),
    [styleCondition, value]
  )

  return (
    <Card sx={{ width: 260, ml: 2, my: 0.5 }}>
      <CardContent>
        <Box display='flex' flexDirection='column'>
          <Box display='flex' justifyContent='space-between'>
            <Typography gutterBottom variant='subtitle1'>
              {title}
            </Typography>
            <Icon aria-label='Metric icon'>
              <BarChartIcon />
            </Icon>
          </Box>

          <Box display='flex' justifyContent='center' alignItems='center'>
            {loading ? (
              <Typography variant='h2'>...</Typography>
            ) : (
              <>
                <Typography sx={{ color: textColor }} variant='h2'>
                  {value}
                </Typography>
                {type === 'currency' && (
                  <Typography sx={{ color: textColor }} variant='h2' ml={0.5}>
                    €
                  </Typography>
                )}
              </>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default MetricCard
